<template>
  <div class="materiel-general">
    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Type de matériel</label>
          <select
            v-model.number="localMateriel.materiel_type_id"
            class="form-control"
            @change="updateMateriel"
          >
            <option :value="null">Sélectionner un type</option>
            <option
              v-for="type in data.materielTypes"
              :key="type.id"
              :value="type.id"
            >
              {{ type.description }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>État</label>
          <select
            v-model.number="localMateriel.materiel_etat_id"
            class="form-control"
            @change="updateMateriel"
          >
            <option :value="null">Sélectionner un état</option>
            <option
              v-for="etat in data.materielEtats"
              :key="etat.id"
              :value="etat.id"
            >
              {{ etat.description }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Fournisseur</label>
          <select
            v-model.number="localMateriel.materiel_fournisseur_id"
            class="form-control"
            @change="updateMateriel"
          >
            <option :value="null">Sélectionner un fournisseur</option>
            <option
              v-for="fournisseur in data.fournisseurs"
              :key="fournisseur.id"
              :value="fournisseur.id"
            >
              {{ fournisseur.description }}
            </option>
          </select>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Société</label>
          <select
            v-model.number="localMateriel.materiel_societe_id"
            class="form-control"
            @change="updateMateriel"
          >
            <option :value="null">Sélectionner une société</option>
            <option
              v-for="societe in data.societes"
              :key="societe.id"
              :value="societe.id"
            >
              {{ societe.description }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Identifiant</label>
          <input
            v-model="localMateriel.identifiant"
            type="text"
            class="form-control"
            placeholder="Saisir l'identifiant"
            @input="updateMateriel"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Description</label>
          <input
            v-model="localMateriel.description"
            type="text"
            class="form-control"
            placeholder="Saisir la description"
            @input="updateMateriel"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>N° de série</label>
          <input
            v-model="localMateriel.num_serie"
            type="text"
            class="form-control"
            placeholder="Saisir le numéro de série"
            @input="updateMateriel"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Lieu de stockage</label>
          <input
            v-model="localMateriel.lieu_stockage"
            type="text"
            class="form-control"
            placeholder="Saisir le lieu de stockage"
            @input="updateMateriel"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Marque</label>
          <input
            v-model="localMateriel.marque"
            type="text"
            class="form-control"
            placeholder="Saisir la marque"
            @input="updateMateriel"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Modèle</label>
          <input
            v-model="localMateriel.modele"
            type="text"
            class="form-control"
            placeholder="Saisir le modèle"
            @input="updateMateriel"
          />
        </div>
      </div>
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <div class="form-group">
          <Checkbox
            v-model="materielSuivi"
            text="Matériel suivi"
            @change="updateMateriel"
          ></Checkbox>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <div class="form-group">
          <label>Date de commande</label>
          <input
            v-model="localMateriel.date_commande"
            type="date"
            class="form-control"
            @input="updateMateriel"
          />
        </div>
      </div>

      <div class="col-md-4">
        <div class="form-group">
          <label>Date de livraison</label>
          <input
            v-model="localMateriel.date_livraison"
            type="date"
            class="form-control"
            @input="updateMateriel"
          />
        </div>
      </div>
      <div class="col-md-4">
        <div class="form-group">
          <label>Date de validité</label>
          <input
            v-model="localMateriel.date_validite"
            type="date"
            class="form-control"
            @input="updateMateriel"
          />
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>Commentaire</label>
          <textarea
            v-model="localMateriel.commentaire"
            class="form-control"
            rows="3"
            placeholder="Saisir des commentaires"
            @input="updateMateriel"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Checkbox from "@/components/bases/Checkbox.vue";

export default {
  components: {
    Checkbox
  },
  props: {
    materiel: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      internalMateriel: {}
    };
  },
  computed: {
    localMateriel: {
      get() {
        return Object.keys(this.internalMateriel).length > 0
          ? this.internalMateriel
          : this.materiel;
      },
      set(value) {
        this.internalMateriel = { ...value };
        this.updateMateriel();
      }
    },
    materielSuivi: {
      get() {
        return this.localMateriel.suivi === 1;
      },
      set(value) {
        this.internalMateriel = { ...this.localMateriel };
        this.internalMateriel.suivi = value ? 1 : 0;
      }
    }
  },
  watch: {
    materiel: {
      handler(newVal) {
        this.internalMateriel = { ...newVal };
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    updateMateriel() {
      this.$emit("update", this.internalMateriel);
    }
  }
};
</script>

<style scoped>
.materiel-general {
  padding: 20px;
}
.form-group {
  margin-bottom: 1rem;
}
.form-group label {
  font-weight: 600;
  margin-bottom: 0.5rem;
}
</style>
